export interface ShareData {
  title?: string;
  text?: string;
  url?: string;
}

// Kiểm tra xem Web Share API có được hỗ trợ không
export const isWebShareSupported = (): boolean => {
  return typeof navigator !== 'undefined' && 'share' in navigator;
};

// Biến để tránh multiple calls
let isSharing = false;

// Hàm chia sẻ chính - chỉ sử dụng Web Share API
export const shareContent = async (data: ShareData): Promise<void> => {
  // Tránh multiple calls đồng thời
  if (isSharing) {
    return;
  }

  isSharing = true;

  try {
    // Lấy URL hiện tại nếu không có URL được cung cấp
    const shareData: ShareData = {
      title: data.title || document.title,
      text: data.text,
      url: data.url || window.location.href
    };

    // Chỉ sử dụng Web Share API
    if (isWebShareSupported()) {
      try {
        await navigator.share(shareData);
      } catch (error) {
        // Nếu user cancel hoặc có lỗi, không làm gì cả
        console.log('Share cancelled or failed:', error);
      }
    } else {
      // Note: This should be handled by the calling component with a notification system
      console.warn('Web Share API not supported. Component should show user-friendly notification.');
      throw new Error(
        'Trình duyệt của bạn không hỗ trợ tính năng chia sẻ. Vui lòng sử dụng trình duyệt hiện đại hơn hoặc sao chép URL từ thanh địa chỉ.'
      );
    }
  } finally {
    // Reset flag ngay lập tức
    isSharing = false;
  }
};

// Hàm copy link - được tối ưu để tránh hiệu ứng "nháy"
// export const copyToClipboard = async (text: string): Promise<boolean> => {
//     try {
//         if (navigator.clipboard && window.isSecureContext) {
//             await navigator.clipboard.writeText(text);
//             return true;
//         } else {
//             // Fallback cho các trình duyệt cũ - tối ưu để tránh "nháy"
//             return new Promise((resolve) => {
//                 const textArea = document.createElement('textarea');
//                 textArea.value = text;

//                 // CSS để hoàn toàn ẩn element và tránh layout shift
//                 textArea.style.cssText = `
//                     position: absolute !important;
//                     left: -9999px !important;
//                     top: -9999px !important;
//                     width: 1px !important;
//                     height: 1px !important;
//                     padding: 0 !important;
//                     margin: 0 !important;
//                     border: none !important;
//                     outline: none !important;
//                     box-shadow: none !important;
//                     background: transparent !important;
//                     opacity: 0 !important;
//                     pointer-events: none !important;
//                 `;

//                 document.body.appendChild(textArea);

//                 // Sử dụng requestAnimationFrame để đảm bảo DOM đã render
//                 requestAnimationFrame(() => {
//                     try {
//                         textArea.focus();
//                         textArea.select();
//                         const result = document.execCommand('copy');
//                         document.body.removeChild(textArea);
//                         resolve(result);
//                     } catch (error) {
//                         document.body.removeChild(textArea);
//                         resolve(false);
//                     }
//                 });
//             });
//         }
//     } catch (error) {
//         console.error('Failed to copy to clipboard:', error);
//         return false;
//     }
// };
